module.exports = __webpack_public_path__ + "img/CherryCashFreeGames_EGM.3612f408.jpg";